"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathUtils = void 0;
var MathUtils = /** @class */ (function () {
    function MathUtils() {
    }
    MathUtils.randomInt = function (min, max) {
        var minCeil = Math.ceil(min);
        var maxFloor = Math.floor(max);
        // The maximum is inclusive and the minimum is inclusive
        return Math.floor(Math.random() * (maxFloor - minCeil + 1)) + minCeil;
    };
    MathUtils.round = function (value, decimals) {
        if (decimals === void 0) { decimals = 2; }
        // tslint:disable-next-line:no-any prefer-template
        return Number(Math.round((value + ("e" + decimals))) + ("e-" + decimals));
    };
    MathUtils.isOdd = function (num) {
        return (num % 2) === 1;
    };
    /**
     * The "range" of a list a numbers is the difference between the largest and
     * smallest values.
     */
    // public static range(numbers: number[]): number[] {
    //   numbers.sort();
    //   return [numbers[0], numbers[numbers.length - 1]];
    // }
    /**
     * The "mode" is the number that is repeated most often.
     */
    MathUtils.mode = function (numbers) {
        // as result can be bimodal or multi-modal,
        // the returned result is provided as an array
        // mode of [3, 5, 4, 4, 1, 1, 2, 3] = [1, 3, 4]
        var modes = [];
        var count = [];
        var num;
        var maxIndex = 0;
        var i;
        for (i = 0; i < numbers.length; i += 1) {
            num = numbers[i];
            count[num] = (count[num] || 0) + 1;
            if (count[num] > maxIndex) {
                maxIndex = count[num];
            }
        }
        for (var key in count) {
            if (count.hasOwnProperty(key)) {
                if (count[key] === maxIndex) {
                    modes.push(Number(key));
                }
            }
        }
        return modes;
    };
    /**
     * The "mean" is the "average" you're used to, where you add up all the numbers
     * and then divide by the number of numbers.
     * @param array - input
     * @param precise - ensures result is rounded properly (much slower for large arrays)
     */
    MathUtils.mean = function (array, precise) {
        if (precise === void 0) { precise = false; }
        if (!(array.length > 0)) {
            return 0;
        }
        var avg = array.reduce(function (a, b) { return a + b; }) / array.length;
        // @TODO faster way to do this?
        if (precise) {
            var maxDecimal_1 = 0;
            var count_1;
            array.forEach(function (num) {
                count_1 = MathUtils.countDecimals(num);
                if (count_1 > maxDecimal_1) {
                    maxDecimal_1 = count_1;
                }
            });
            return MathUtils.round(avg, maxDecimal_1);
        }
        else {
            return avg;
        }
    };
    /**
     * The "median" is the "middle" value in the list of numbers.
     */
    MathUtils.median = function (array) {
        var mid = Math.floor(array.length / 2);
        var nums = __spreadArrays(array).sort(function (a, b) { return a - b; });
        return array.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
    };
    MathUtils.countDecimals = function (value) {
        if (Math.floor(value) === value) {
            return 0;
        }
        return value.toString()
            .split('.')[1].length || 0;
    };
    MathUtils.lerp = function (x, y, a) {
        return x * (1 - a) + y * a;
    };
    MathUtils.clamp = function (a, min, max) {
        if (min === void 0) { min = 0; }
        if (max === void 0) { max = 1; }
        return Math.min(max, Math.max(min, a));
    };
    MathUtils.invlerp = function (x, y, a) {
        return this.clamp((a - x) / (y - x));
    };
    MathUtils.range = function (x1, y1, x2, y2, a) {
        return this.lerp(x2, y2, this.invlerp(x1, y1, a));
    };
    return MathUtils;
}());
exports.MathUtils = MathUtils;
